import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

import { EMPTY_STRING, ICON_URLS, PropertiesComponent } from '@app/constants';
import { ToastTypeEnum } from '@app/enums/toast-type.enum';
import { ToastInterface } from '@app/interface/toast.interface';
import { HtmlSanitizationService } from '@app/services/html-sanitization.service';
import { ToastService } from '@app/services/toast.service';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
})
export class ToastComponent implements OnChanges {
  @Input() data: ToastInterface | undefined;
  @Input() show = false;
  @Input() className = '';

  public readonly ToastTypeEnum = ToastTypeEnum;
  public readonly EMPTY_STRING = EMPTY_STRING;

  public readonly iconAlert: Record<string, string> = {
    [ToastTypeEnum.Danger]: ICON_URLS.IconTriangle,
    [ToastTypeEnum.Success]: ICON_URLS.IconSuccess,
    [ToastTypeEnum.Exclaim]: ICON_URLS.IconExclaim,
    [ToastTypeEnum.Waiting]: ICON_URLS.IconWaiting,
    [ToastTypeEnum.Warning]: ICON_URLS.IconWarning,
    [ToastTypeEnum.WarningProcess]: ICON_URLS.IconWarning,
  };

  public readonly urlCloseIconBlack = ICON_URLS.CloseIcon;
  public readonly urlCloseIconWhite = ICON_URLS.CloseWhiteIcon;

  public descriptionHtml: SafeHtml = EMPTY_STRING;
  public showIconCloseBlack = false;

  private readonly darkCloseIconTypes = new Set<string>([
    ToastTypeEnum.Warning,
    ToastTypeEnum.WarningProcess,
  ]);

  constructor(
    private readonly toastService: ToastService,
    private readonly htmlSanitizationService: HtmlSanitizationService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes[PropertiesComponent.data]) {
      return;
    }

    const toast = changes[PropertiesComponent.data].currentValue as ToastInterface | undefined;

    const description = toast?.description || EMPTY_STRING;

    this.descriptionHtml = this.htmlSanitizationService.sanitize(description);

    this.showIconCloseBlack = this.darkCloseIconTypes.has(toast?.type || EMPTY_STRING);
  }

  get icon(): string {
    return this.iconAlert[this.data?.type || ToastTypeEnum.Danger];
  }

  get closeIcon(): string {
    return this.showIconCloseBlack ? this.urlCloseIconBlack : this.urlCloseIconWhite;
  }

  closeToast(): void {
    this.toastService.close();
  }

  onButtonClick($event: unknown): void {
    this.data?.button?.callback?.($event);
    if (this.data?.button?.closeOnClick) {
      this.closeToast();
    }
  }
}
